import { render, staticRenderFns } from "./LevelComponent.vue?vue&type=template&id=93097e80&"
import script from "./LevelComponent.vue?vue&type=script&lang=js&"
export * from "./LevelComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports